import { render, staticRenderFns } from "./BaseStylableTextarea.vue?vue&type=template&id=0346e4ae&lang=html"
import script from "./BaseStylableTextarea.vue?vue&type=script&lang=js"
export * from "./BaseStylableTextarea.vue?vue&type=script&lang=js"
import style0 from "./BaseStylableTextarea.vue?vue&type=style&index=0&id=0346e4ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports